// extracted by mini-css-extract-plugin
export default {"category-rf":"styles_category-rf__hGrZV","category-fig":"styles_category-fig__exVQW","category-item":"styles_category-item__3Wde9"};